import { useState } from "react";
import { useMutation } from "react-query";
import {
  reactQueryPost,
  reactQueryDelete,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";
import { t } from "@/i18n-js/instance";

interface UseBlockMemberProps {
  memberName?: string;
  onSuccess?: () => void;
  setIsBlockDmsModalOpen: (isOpen: boolean) => void;
}

interface MemberToBlock {
  community_member_id: number;
  id: number;
  name: string;
}

export const useBlockMember = ({
  onSuccess,
  setIsBlockDmsModalOpen,
  memberName,
}: UseBlockMemberProps) => {
  const [memberToBlock, setMemberToBlock] = useState<MemberToBlock | null>(
    null,
  );
  const toastr = useToast();
  const { mutate: blockMember, isLoading: isBlocking } = useMutation(
    async ({ memberId }: { memberId: number }) => {
      await reactQueryPost(
        internalApi.blockedMembers.create({
          params: {
            blocked_member_id: memberId,
          },
        }),
      );
    },
    {
      onError: (error: Error) => {
        toastr.error(error.message);
      },
      onSuccess: () => {
        toastr.success(
          t("messaging.block_direct_messages_modal.success", {
            name: memberToBlock?.name || memberName,
          }),
        );
        setIsBlockDmsModalOpen(false);
        onSuccess?.();
      },
    },
  );

  interface UnBlockMemberProps {
    memberId: number;
    name?: string;
  }

  const { mutate: unBlockMember, isLoading: isUnblocking } = useMutation(
    async ({ memberId }: UnBlockMemberProps) => {
      await reactQueryDelete(
        internalApi.blockedMembers.destroy({
          id: memberId,
        }),
      );
    },
    {
      onError: (error: Error) => {
        toastr.error(error.message);
      },
      onSuccess: (_, { name }) => {
        toastr.success(
          t("messaging.unblock_direct_messages_success", {
            name: name || memberName,
          }),
        );
        onSuccess?.();
      },
    },
  );

  return {
    blockMember,
    isBlocking,
    memberToBlock,
    setMemberToBlock,
    unBlockMember,
    isUnblocking,
  };
};
